export default "__VITE_ASSET__DsSI_IIH__"